import { render, staticRenderFns } from "./ViewProductsLoadingsCodes.vue?vue&type=template&id=6fa5cfb8&"
import script from "./ViewProductsLoadingsCodes.vue?vue&type=script&lang=js&"
export * from "./ViewProductsLoadingsCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports